import React, { useMemo, useState } from 'react';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';

type Props = {
  previewUrl: string;
  fileType: string;
  fileName: string;
};

const PREVIEWABLE_MIME_TYPES = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif'];

const ApproveItemFilePreview: React.FC<Props> = ({ previewUrl, fileType, fileName }) => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);
  const isPreviewable = PREVIEWABLE_MIME_TYPES.includes(fileType);
  const [isOpen, setIsOpen] = useState(false);
  const [hasError, setHasError] = useState(false);

  if (!isPreviewable || hasError) return null;

  const isPdf = fileType === 'application/pdf';

  return (
    <div style={styles.wrapper}>
      <button
        type="button"
        aria-expanded={isOpen}
        onClick={() => setIsOpen(prev => !prev)}
        style={styles.toggleButton}
      >
        {isOpen ? 'プレビューをとじる ▼' : 'プレビューを表示 ▼'}
      </button>
      {isOpen && (
        <div style={styles.body}>
          {isPdf ? (
            <iframe src={previewUrl} title={fileName} style={styles.pdfFrame} />
          ) : (
            <img src={previewUrl} alt={fileName} onError={() => setHasError(true)} style={styles.previewImage} />
          )}
        </div>
      )}
    </div>
  );
};

const getStyles = (theme: AITTheme) => ({
  wrapper: {
    marginTop: 8,
    width: '100%' as const
  },
  toggleButton: {
    background: 'none',
    border: 'none',
    padding: '4px 0',
    color: theme.tokens.colors.brand.primary,
    cursor: 'pointer' as const
  },
  body: {
    marginTop: 8
  },
  pdfFrame: {
    width: '100%',
    height: 800,
    border: `1px solid ${theme.tokens.colors.border.field}`,
    borderRadius: 4
  },
  previewImage: {
    maxWidth: '100%',
    maxHeight: 800,
    objectFit: 'contain' as const,
    border: `1px solid ${theme.tokens.colors.border.field}`,
    borderRadius: 4
  }
});

export default ApproveItemFilePreview;
